import React, { useEffect, useRef, useState, useCallback } from 'react';
import './VracTuto.scss';

const steps = [
    {
        number: 1,
        img: '/assets/Home/VracTuto/peserV2.webp',
        alt: 'bocal à peser',
        text: (<>On <span className='tuto-cursive'>pèse</span> le contenant vide</>),
    },
    {
        number: 2,
        img: '/assets/Home/VracTuto/remplirV2.webp',
        alt: 'pelle pour remplir son contenant',
        text: (<>On le <span className='tuto-cursive'>remplit</span> de la quantité <span className='tuto-cursive'>désirée</span></>),
    },
    {
        number: 3,
        img: '/assets/Home/VracTuto/payerV2.webp',
        alt: 'prêt pour le passage en caisse',
        text: (<>On paie <span className='tuto-cursive'>uniquement</span> le produit</>),
    },
    {
        number: 4,
        img: '/assets/Home/VracTuto/conserverV2.webp',
        alt: 'contenant conserver selon les recommandations',
        text: (<>On le <span className='tuto-cursive'>conserve</span> selon les <span className='tuto-cursive'>recommandations</span></>),
    },
];

function VracTuto() {
    const rowRef = useRef(null);
    const [canScroll, setCanScroll] = useState(false);
    const [progress, setProgress] = useState(25);

    // Indicateur de défilement : visible seulement si les étapes débordent (mobile).
    const update = useCallback(() => {
        const row = rowRef.current;
        if (!row) return;
        const scrollable = row.scrollWidth > row.clientWidth + 4;
        setCanScroll(scrollable);
        if (scrollable) setProgress(100 * (row.scrollLeft + row.clientWidth) / row.scrollWidth);
    }, []);

    useEffect(() => {
        const row = rowRef.current;
        if (!row) return undefined;
        update();
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        return () => {
            row.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
        };
    }, [update]);

    return (
        <div className='vracTuto-section'>
            <h2 className='titre-home'>Rien de plus simple :</h2>
            <div className='vracTuto-scroller'>
                <div className='vracTuto-container' ref={rowRef}>
                    {steps.map((step, index) => (
                        <React.Fragment key={step.number}>
                            <div className="case-tuto">
                                <div className="case-tuto__img-wrapper">
                                    <div className="step-badge">{step.number}</div>
                                    <img src={step.img} alt={step.alt} />
                                </div>
                                <p className="case-tuto__text">{step.text}</p>
                            </div>
                            {index < steps.length - 1 && (
                                <div className="step-connector" aria-hidden="true">
                                    <svg viewBox="0 0 24 24"><path d="M4 12h16M14 6l6 6-6 6"/></svg>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            {canScroll && (
                <div className='scroll-hint' aria-hidden="true">
                    <div className='scroll-hint__bar'><i style={{ width: `${progress.toFixed(1)}%` }}></i></div>
                    <svg className='scroll-hint__arrow' viewBox="0 0 24 24"><path d="M4 12h16M14 6l6 6-6 6"/></svg>
                </div>
            )}
        </div>
    );
}

export default VracTuto;
